import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-ag-grid-loading-cell-renderer',
  imports: [CommonModule, MatProgressSpinner],
  templateUrl: './ag-grid-loading-cell-renderer.component.html',
  styleUrl: './ag-grid-loading-cell-renderer.component.scss'
})
export class AgGridLoadingCellRendererComponent implements ICellRendererAngularComp {
  value: any;
  loaded = false;

  agInit(params: any): void {
    this.updateValue(params);
  }

  refresh(params: any): boolean {
    this.updateValue(params);
    return true;
  }

  private updateValue(params: any) {
    if (params.value != null) {
      this.value = params.valueFormatted || params.value;
      this.loaded = true;
    } else {
      this.loaded = false;
    }
  }
}
